import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconExpandMoreDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M2.325 7.322a1.12 1.12 0 0 1 1.572 0L12 15.344l8.103-8.022a1.12 1.12 0 0 1 1.572 0c.433.43.433 1.126 0 1.556l-8.89 8.8a1.12 1.12 0 0 1-1.57 0l-8.89-8.8a1.09 1.09 0 0 1 0-1.556" clipRule="evenodd" /></svg></>;
}
export default IconExpandMoreDefault;